<template>
  <div>
    <div
      class="bg-white pt-3 p-2 border-form"
      :class="hasStepGuide ? 'radius-content' : ''"
    >
      <b-row>
        <b-col
          md="12"
          xs="12"
        >
          <label class="font-14 mrb-10">Select country - currency</label>
          <v-select
            v-model="coinType"
            class="coin-select select-info"
            label="name"
            :options="coinTypes"
            :clearable="false"
            @input="handleChangeCoin"
          >
            <template #open-indicator="{ attributes }">
              <span v-bind="attributes">
                <feather-icon
                  icon="ChevronDownIcon"
                  size="20"
                />
              </span>
            </template>

            <template #selected-option="{ icon, name, value }">
              <img
                v-if="icon"
                class="coin-spacing"
                alt="flag"
                style="width: 26px;height: auto"
                :src="icon"
              >
              <strong class="coin-spacing">{{ name }}</strong> - {{ value }}
            </template>

            <template #option="{ icon, name, value }">
              <img
                v-if="icon"
                class="coin-spacing"
                alt="flag"
                style="width: 26px;height: auto"
                :src="icon"
              >
              <strong>{{ name }}</strong> - {{ value }}
            </template>
          </v-select>
        </b-col>
        <b-col md="12">
          <div class="btn-register">
            <div class="icon">
              <img
                class="img-icon"
                alt="flag"
                :src="require('@/assets/images/pages/payment/ic-register-airwallex.svg')"
              >
            </div>
            <div class="content-btn">
              <p>
                Hi friend, if you don't have any account right here, you can sign up to get the best fees and benefits right now!
              </p>
            </div>
            <div class="btn-airwallex">
              <a
                href="https://www.airwallex.com/signup?utm_source=a11BB0000007QqhYAE"
                target="_blank"
                class="content-btn-register"
              >
                <span>Register with</span>
                <img
                  alt="logo-airwallex"
                  :src="require('@/assets/images/pages/payment/logo-airWallex.svg')"
                >
              </a>
            </div>
          </div>
        </b-col>
      </b-row>

    </div>
  </div>
</template>

<script>
import { BRow, BCol, VBTooltip } from 'bootstrap-vue'
import vSelect from 'vue-select'
import { TRANSFER_NETWORKS, BANK_ACCOUNTS } from '@/constants'
import paymentMixin from '@/mixins/paymentMixin'
import envMixin from '@/mixins/envMixin'
import stepGuideMixin from '@/mixins/stepGuideMixin'

export default {
  components: {
    BRow,
    BCol,
    vSelect,
  },

  directives: {
    'b-tooltip': VBTooltip,
  },

  mixins: [paymentMixin, envMixin, stepGuideMixin],

  props: {
    method: {
      type: Object,
      default() {
        return BANK_ACCOUNTS[0]
      },
      required: true,
    },

    transfer: {
      type: Object,
      default() {
        return TRANSFER_NETWORKS[0]
      },
      required: true,
    },
    options: {
      type: Array,
      default: () => BANK_ACCOUNTS,
    },
  },

  data() {
    return {
      coinTypes: this.options,
      coinType: this.method,
      transferNetworks: TRANSFER_NETWORKS,
      transferNetwork: this.transfer,
    }
  },

  watch: {
    options: {
      handler(val) {
        if (val && val.length > 0) {
          this.coinTypes = val
          // Optional: select the first option if current selection is invalid?
          // For now just update the list.
          if (!this.coinType || !val.find(c => c.value === this.coinType.value && c.name === this.coinType.name)) {
            const [firstOption] = val
            this.coinType = firstOption
            this.handleChangeCoin(this.coinType)
          }
        }
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    handleChangeCoin(value) {
      this.$emit('on-change', value)
    },

    handleChangeTransferNetwork(value) {
      this.$emit('on-change-transfer', value)
    },
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';

.coin-spacing {
  margin-right: 5px;
}

.coin-select {
  width: 368px;
}
.select-info {
  &:hover {
    background-color: #fff;
  }
}
</style>
<style lang="scss" scoped>
.radius-content {
  border-radius: 0px 0px 24px 24px !important;
}

  .border-form{
    border-radius: var(--border-radius-base);
  }

  .coin-select{

    @media (max-width: 767px) {
      width: 100%;
    }
  }

  .btn-register{
    display: flex;
    align-items: center;
    justify-content: space-between;

    background: linear-gradient(90deg, rgba(255, 79, 66, 0.1) 0.12%, rgba(255, 142, 60, 0.1) 100.23%);
    border-radius: 12px;

    margin-top: 24px;
    padding: 12px;

    .icon{
      max-width: 40px;
      width: 100%;

      .img-icon{
        width: 100%;
      }
    }

    .content-btn{
      margin: 0 20px 0 12px;

      font-size: 14px;

      p{
        margin: 0;
      }

      @media (max-width: 767px) {
        margin: 12px 0;
      }
    }

    .btn-airwallex{

      .content-btn-register{
        color: #fff;
        background: linear-gradient(90deg, #FF4F42 0.12%, #FF8E3C 100.23%);
        border-radius: 100px;

        width: max-content;

        display: flex;
        align-items: center;

        padding: 8px 16px;

        font-size: 14px;

        span{
          margin-right: 8px;
        }
      }

    }

    @media (max-width: 767px) {
      flex-direction: column;
    }
  }
</style>
